import eventSenderMixin from './io/eventSenderMixin'
import calendarSenderMixin from './io/calendarSenderMixin'

export default {
  mixins: [eventSenderMixin, calendarSenderMixin],
  emits: ['deleted', 'view'],
  methods: {
    async baseSetStatus (id, val, successCallback = () => {}, doneCallback = () => {}, errorCallback = () => {}) {
      const { status } = await this.$put('v1/appointments/status', {
        id,
        status: val
      })
      doneCallback()
      if (status === 'success') {
        const sendPayload = {
          id,
          status: val
        }

        this.$bus.emit('calendar:status', sendPayload)
        this.ioCalendarStatus(sendPayload)
        this.ioEventStatus(sendPayload)
        this.$q.notify({
          color: 'green',
          message: 'Appointment status successfully changed.'
        })
        successCallback()
      }
      else {
        errorCallback()
      }
    },
    async baseDeleteAppointment (id, deleteAction = 'none', successCallback = () => {}) {
      this.$loading.show({
        message: 'Deleting Appointment...'
      })
      const { status, payload } = await this.$remove('v1/appointments', {
        id,
        delete_action: deleteAction
      })
      this.$loading.hide()
      if (status === 'success') {
        this.$bus.emit('calendar:remove', payload.deleted_ids)
        this.ioCalendarRemove(payload.deleted_ids)
        this.ioEventRemove(payload.deleted_ids)
        this.$q.notify({
          color: 'green',
          message: 'Appointment successfully deleted.'
        })
        this.$emit('deleted')
      }
      successCallback()
    },
    async baseMarkAsUnscheduled (id) {
      this.$loading.show({
        message: 'Marking Appointment as unscheduled...'
      })
      const { status, payload } = await this.$post('v1/appointments/unscheduled/mark', {
        id
      })
      this.$loading.hide()
      if (status === 'success') {
        this.$bus.emit('calendar:remove', [parseInt(id)])
        this.ioCalendarUnscheduled([id])
        this.ioEventUpdate(id)
        setTimeout(() => {
          this.$bus.emit('calendar:unscheduled:add', payload.appointment)
        }, 250)
        this.$q.notify({
          color: 'green',
          message: 'Appointment successfully marked as unscheduled.'
        })
      }
    },
    baseOpenAppointment (id) {
      this.$bus.emit('calendar:open', parseInt(id))
      this.$emit('view')
    }
  }
}
